import { render } from "./RelationshipPostcardFlow.vue?vue&type=template&id=0280d57b&scoped=true"
import script from "./RelationshipPostcardFlow.vue?vue&type=script&lang=js"
export * from "./RelationshipPostcardFlow.vue?vue&type=script&lang=js"

import "./RelationshipPostcardFlow.vue?vue&type=style&index=0&id=0280d57b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0280d57b"]])

export default __exports__